import styled from 'styled-components'
import { TEXT_GREY, FONT_BASE_COLOR, GREY_BACKGROUND,
  SELECTED_ITEM_BG_COLOR, LINK_COLOR, PRIMARY_DARK_COLOR } from '@CSSVars/colors'

export const _NearbyMapCta = styled.div`
  width: 100%;
  margin: ${({ sideBarStyle }) => (sideBarStyle ? '0 0 12px' : '24px 0 0')};
    &:hover,
    &:focus {
      cursor: pointer;
    }
  height:  ${({ isMapOnlyView }) => (isMapOnlyView ? '160px' : '240px')};
  ${({ isMapOnlyView }) => (
    isMapOnlyView ?
      `
       position: relative;

      ` : `
        background: ${GREY_BACKGROUND};
        border-radius: 10px;

      `
  )}
  ${({ sideBarStyle, isMapOnlyView }) => (
    !sideBarStyle && !isMapOnlyView ?
      `
       display:none;

      ` : ''
  )}
  }
`
export const _Title = styled.div`
  color: ${FONT_BASE_COLOR};
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
`

export const _ImageBorder = styled.div`
  overflow: hidden;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  ${({ isMapOnlyView }) => (
    isMapOnlyView ?
      `
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;

      ` : ''
  )}
}
`

export const _ImageHolder = styled.div`
  width: 100%;
  height:  ${({ isMapOnlyView }) => (isMapOnlyView ? '160px' : '120px')};
  background-size: cover;
  background-position: center;
  image-rendering: -webkit-optimize-contrast;
  &:hover {
    transition: 1s ease;
    transform: scale(1.1);
  }
  &:active {
    filter: brightness(90%);
  }
`


export const _Text = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color:${TEXT_GREY};
  font-size: 14px;
  line-height: 16px;
  margin-top: 6px;
  font-weight: 500;
`

export const _CaptionContainer = styled.div`
  background: ${GREY_BACKGROUND};
  height: 74px;
  padding: 10px 24px 24px 24px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`
export const _NearbyCtaMobile = styled.div`
  height: 36px;
  position: absolute;
  bottom: 17px;
  left: 50%;
  transform:translateX(-50%);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  width: 60%;
  color: ${FONT_BASE_COLOR};
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  text-decoration: none;
  //color: ${LINK_COLOR};
  border-radius: 10px;
  &:active{
    color: ${SELECTED_ITEM_BG_COLOR};
  }
`

export const _DirectionContainer = styled.div`
  margin-left: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  cursor: pointer;
  svg {
    rect{
      fill: ${PRIMARY_DARK_COLOR};
    }
  }
  `

export const _DirectionCaption = styled.div`
  color: ${PRIMARY_DARK_COLOR};
  margin-left: 5px;
  font-size: 14px;
  line-height: 22px;
  `
